<template>
  <div class="header-content">
    <img class="meun-icon" src="@/assets/menu-icon.png" alt="menu" @click="visible=true">
    <div class="title">{{ config.title }}</div>
    <div class="nav-content">
      <div @click="scrollPage('screeshots')">Screenshots</div>
      <div class="line">|</div>
      <div @click="scrollPage('introduction')">Introduction</div>
    </div>
    <div class="phone-menu" v-show="visible">
      <div class="menu-tilte">{{ config.title }}</div>
      <div class="pd-50">
        <div class="phone-menu-item" @click="scrollPage('screeshots')">
          <span>Screenshots</span>
          <span>></span>
        </div>
        <div class="phone-menu-item" @click="scrollPage('introduction')">
          <span>Introduction</span>
          <span>></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
      //定时器
      timeOut: null,
      visible: false
    }
  },
  methods: {
    scrollPage(id) {
      clearInterval(this.timeOut)
      let end = document.getElementById(id).offsetTop
      let start = window.pageYOffset
      let step = (end - start) / 100
      let current = 0
      if(end < start) {
        this.timeOut = setInterval(() => {
          start += step
          if (start <= end) {
              clearInterval(this.timeOut)
              start = end
              this.timeOut = null
          }
          if (current === start) {
              return
          }
          window.scrollTo(0,start)
        }, 5)
      }else{
        this.timeOut = setInterval(() => {
          start += step
          if (start >= end) {
              clearInterval(this.timeOut)
              start = end
              this.timeOut = null
          }
          if (current === start) {
              return
          }
          window.scrollTo(0,start)
        }, 5)
      }
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  height: 100px;
  padding: 0 280px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  color: #000;
  .meun-icon{
    display: none;
  }
  .title{
    font-size: 30px;
    color: #000;
    font-weight: 600;
  }
  .nav-content{
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 23px;
    font-weight: 600;
    color: #000;
    .line{
      margin: 0 35px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    height: 100px;
    padding: 0;
    justify-content: flex-start;
    .meun-icon{
      display: block;
      width: 40px;
      height: 40px;
      margin-left: 30px;
      margin-right: 85px;
    }
    .nav-content{
      display: none;
    }
    .phone-menu{
      z-index: 10;
      position: fixed;
      top: 0;
      left: 0;
      width: 530px;
      height: 100%;
      background: #333;
      .menu-tilte{
        width: 100%;
        height: 100px;
        background: #000;
        color: #fff;
        font-size: 30px;
        text-align: center;
        line-height: 100px;
      }
      .pd-50{
        padding: 50px;
      }
      .phone-menu-item{
        color: #fff;
        font-size: 35px;
        line-height: 100px;
        border-bottom: 2px solid #fff;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  
}
</style>